import { Durations } from "../../../SubjectData/BasicWords/Time.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";

export default function DurationsDeck() {
  return (
    <>
      <HeaderNav GoBack_to="/TimeNav" />
      <FlashcardInterface deckData={Durations} title="Durations" />
    </>
  );
}
